<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin" style="display: block;">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close" @click="$emit('close')"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_welcome_back_returning_back_welcome_back }} {{ userDetails.username }}!</h1>
          <img class="modal_icon_main" src="static/images/re_subscribe.png" alt="">
          <p>{{ getTranslations.home_modals_welcome_back_returning_back_you_start }}</p>
        </div>
        <div class="modal__footer" v-if="!reoptinOnestep"><span class="terms">
          <span class="make_it_bold">{{ getTranslations.home_modals_welcome_back_returning_back_note }}</span>
          {{ getTranslations.home_modals_welcome_back_returning_back_do_not }}<br></span></div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  // modal_resubscribe_welcome_back.html
  name: 'welcome-returning-unsub',
  computed: {
    ...mapState('common', [
      'reoptinOnestep',
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeReturningUnsub.vue